import { Container, styled } from "@mui/material";

export const StyledLoginFormContainer = styled(Container)({
	height: "100%",
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
});
